var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ordersxpage"},[_c('span',{staticClass:"ordersxpage__label"},[_vm._v(" "+_vm._s(_vm.$t('admin.dashboard.perpage'))+" ")]),_c('CustomSelect',{attrs:{"options":_vm.options,"default":"10","tabindex":_vm.tabindex,"direction":"up","filter":"item_per_page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }